import React from "react";
import { 
  Box, 
  Heading, 
  VStack, 
  Text, 
  Container, 
  useColorModeValue, 
  Button, 
  Icon,
  Flex,
  Select,
  Image
} from "@chakra-ui/react";
import { FaPlusCircle, FaSearch } from "react-icons/fa";
import PostListingForm from "../../components/PostListingForm";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const PostListingPage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const bgColor = useColorModeValue("gray.50", "gray.900");
  const textColor = useColorModeValue("gray.700", "white");
  const heroBgColor = useColorModeValue("green.50", "green.900");
  const accentColor = useColorModeValue("green.500", "green.300");

  // Handle Language Change
  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Box bg="brand.200" color="brand.500" minH="100vh">

      {/* Hero Section */}
      <Box 
        py={12}
        px={6}
        textAlign="center"
        borderRadius="lg"
        position="relative"
        overflow="hidden"
        _after={{
          content: `""`,
          position: "absolute",
          top: 0,
          left: 0,
          w: "100%",
          h: "100%",
          bg: "linear-gradient(135deg, rgba(0, 255, 200, 0.3), rgba(0, 0, 100, 0.2))",
          zIndex: -1,
        }}
      >
        <Container maxW="container.md">
          <Heading 
            as={motion.h1}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            size="2xl"
            fontWeight="bold"
            mb={4}
            color="brand.300"
          >
            {t("postlistingpage.hero_title")}
          </Heading>
          <Text 
            as={motion.p}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
            fontSize="xl" 
            mb={6}
            color="brand.400"
          >
            {t("postlistingpage.hero_description")}
          </Text>

          {/* Animated Explore Deals Button */}
          <Flex justify="center" align="center" gap={4}>
            <Button 
              as={motion.button}
              initial={{ scale: 1 }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              leftIcon={<Icon as={FaSearch} />} 
              bg="brand.300"
              color="white"
              fontWeight="bold"
              _hover={{ bg: "brand.100", color: "brand.300", transform: "scale(1.05)" }}
              size="lg"
              shadow="lg"
              transition="0.3s"
              onClick={() => navigate("/personal/listings")}
            >
              {t("postlistingpage.explore_deals_button")}
            </Button>
          </Flex>
        </Container>
      </Box>

      {/* Post Listing Form Section */}
      <Container maxW="container.md" mt={10}>
        <PostListingForm />
      </Container>

    </Box>
  );
};

export default PostListingPage;
